export default [
  {
    path: "/longshort",
    name: "Long & Short",
    component: () =>
      import("@/app/modules/longshort/pages/longshort.component.vue"),
  },
  {
    path: "/longshort/authorization",
    name: "Pré-autorização Long & Short",
    component: () =>
      import("@/app/modules/longshort/pages/authorization.component.vue"),
  },
  {
    path: "/longshort/authorization/create",
    name: "Nova autorização Long & Short",
    component: () =>
      import("@/app/modules/longshort/pages/new-authorization.component.vue"),
  },
  {
    path: "/longshort/params",
    name: "Criar ordem Long & Short",
    component: () =>
      import("@/app/modules/longshort/pages/params.component.vue"),
  },
  {
    path: "/longshort/params/:alg_ord_id",
    name: "Editar ordem Long & Short",
    component: () =>
      import("@/app/modules/longshort/pages/params.component.vue"),
  },
];
